(() => {
  const smoothScrollElement = (element, to, duration = 650) => {
    const start = element.scrollTop;
    const distance = to - start;
    const startTime = performance.now();
    const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

    const tick = (currentTime) => {
      const progress = Math.min((currentTime - startTime) / duration, 1);
      element.scrollTop = start + distance * easeOutCubic(progress);

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    };

    requestAnimationFrame(tick);
  };
  const pcQuery = window.matchMedia("(min-width: 1280px)");

  // SPメニューの開閉
  const menuButton = document.querySelector(".site-header__menu");

  if (menuButton) {
    menuButton.addEventListener("click", () => {
      const isOpen = document.body.classList.toggle("is-nav-open");
      menuButton.setAttribute("aria-expanded", String(isOpen));
    });
  }

  // ページ内リンクのスムーススクロール
  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const hash = link.getAttribute("href");

      if (!hash || hash.length <= 1) {
        return;
      }

      const target = document.querySelector(hash);

      if (!target) {
        return;
      }

      event.preventDefault();
      document.body.classList.remove("is-nav-open");
      if (menuButton) {
        menuButton.setAttribute("aria-expanded", "false");
      }

      const subScrollBody = target.closest(".sub-content__body");
      if (subScrollBody) {
        // 下層ページのscrollボタンは本文エリア内をスムーズに送る
        const targetTop = target.getBoundingClientRect().top - subScrollBody.getBoundingClientRect().top + subScrollBody.scrollTop;
        smoothScrollElement(subScrollBody, targetTop);
        return;
      }

      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  // Page Topボタンの表示切り替え
  const pageTop = document.querySelector(".page-top");

  if (pageTop) {
    const updatePageTop = () => {
      document.body.classList.toggle("is-page-top-visible", window.scrollY > 300);
    };

    updatePageTop();
    window.addEventListener("scroll", updatePageTop, { passive: true });
    window.addEventListener("resize", updatePageTop);
  }

  // TOPページPC時のヘッダーロゴ表示切り替え
  const topAbout = document.querySelector(".top-page .top-about");
  if (topAbout) {
    const updateTopHeader = () => {
      if (!pcQuery.matches) {
        document.body.classList.remove("is-site-logo-visible");
        return;
      }
      const isAboutOverHero = topAbout.getBoundingClientRect().top < 200;

      document.body.classList.toggle("is-site-logo-visible", isAboutOverHero);
    };

    updateTopHeader();
    window.addEventListener("scroll", updateTopHeader, { passive: true });
    window.addEventListener("resize", updateTopHeader);
    if (pcQuery.addEventListener) {
      pcQuery.addEventListener("change", updateTopHeader);
    } else {
      pcQuery.addListener(updateTopHeader);
    }
  }

  // voiceページのお客様の声をスクロール到達時に表示
  const voiceComments = document.querySelectorAll(".voice-comment");

  if (voiceComments.length) {
    const revealVoiceComment = (comment) => {
      comment.classList.add("is-visible");
    };

    const checkVoiceComments = () => {
      voiceComments.forEach((comment) => {
        if (comment.classList.contains("is-visible")) {
          return;
        }

        if (comment.getBoundingClientRect().top <= window.innerHeight * .82) {
          revealVoiceComment(comment);
        }
      });
    };

    if ("IntersectionObserver" in window) {
      const commentObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          revealVoiceComment(entry.target);
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: "0px 0px -16%",
        threshold: .08,
      });

      voiceComments.forEach((comment) => {
        commentObserver.observe(comment);
      });
    } else {
      window.addEventListener("scroll", checkVoiceComments, { passive: true });
      window.addEventListener("resize", checkVoiceComments);
    }

    checkVoiceComments();
  }

  const initSetSlider = (scope = document) => {
    // PRODUCTページのセット画像スライダー
    scope.querySelectorAll("[data-set-slider]").forEach((slider) => {
      if (slider.dataset.sliderReady === "true") {
        return;
      }
      slider.dataset.sliderReady = "true";

      const section = slider.closest(".product-set");
      const slides = Array.from(slider.querySelectorAll(".product-set__track img"));
      const dots = Array.from(slider.querySelectorAll(".product-set__dots button"));
      const plans = section ? Array.from(section.querySelectorAll("[data-slide-index]")) : [];

      if (slides.length <= 1) {
        return;
      }

      let activeIndex = slides.findIndex((slide) => slide.classList.contains("is-active"));
      let timerId;

      if (activeIndex < 0) {
        activeIndex = 0;
        slides[0].classList.add("is-active");
      }

      const showSlide = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        slider.dataset.activeIndex = String(activeIndex);
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle("is-active", isActive);
          slide.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle("is-active", isActive);
          if (isActive) {
            dot.setAttribute("aria-current", "true");
          } else {
            dot.removeAttribute("aria-current");
          }
        });
      };

      const startAutoPlay = () => {
        window.clearInterval(timerId);
        timerId = window.setInterval(() => {
          showSlide(activeIndex + 1);
        }, 4500);
      };

      const stopAutoPlay = () => {
        window.clearInterval(timerId);
      };

      plans.forEach((plan) => {
        const index = Number(plan.dataset.slideIndex);

        if (Number.isNaN(index)) {
          return;
        }

        plan.addEventListener("mouseenter", () => showSlide(index));
        plan.addEventListener("focusin", () => showSlide(index));
      });

      slider.addEventListener("mouseenter", stopAutoPlay);
      slider.addEventListener("mouseleave", startAutoPlay);
      slider.addEventListener("focusin", stopAutoPlay);
      slider.addEventListener("focusout", startAutoPlay);

      showSlide(activeIndex);
      startAutoPlay();
    });
  };

  initSetSlider();

  document.addEventListener("shopify:section:load", (event) => {
    initSetSlider(event.target);
  });

  document.addEventListener("click", (event) => {
    const arrow = event.target.closest(".product-set__arrow");
    const dot = event.target.closest(".product-set__dots button");
    const control = arrow || dot;

    if (!control) {
      return;
    }

    const slider = control.closest("[data-set-slider]");

    if (!slider) {
      return;
    }

    const slides = Array.from(slider.querySelectorAll(".product-set__track img"));
    const dots = Array.from(slider.querySelectorAll(".product-set__dots button"));

    if (slides.length <= 1) {
      return;
    }

    let nextIndex = Number(slider.dataset.activeIndex || 0);

    if (dot) {
      nextIndex = dots.indexOf(dot);
    } else if (control.classList.contains("product-set__arrow--prev")) {
      nextIndex -= 1;
    } else {
      nextIndex += 1;
    }

    nextIndex = (nextIndex + slides.length) % slides.length;
    slider.dataset.activeIndex = String(nextIndex);

    slides.forEach((slide, index) => {
      const isActive = index === nextIndex;
      slide.classList.toggle("is-active", isActive);
      slide.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    dots.forEach((dotButton, index) => {
      const isActive = index === nextIndex;
      dotButton.classList.toggle("is-active", isActive);
      if (isActive) {
        dotButton.setAttribute("aria-current", "true");
      } else {
        dotButton.removeAttribute("aria-current");
      }
    });
  });

  // voiceページのグラフ表示アニメーション
  const graphSections = document.querySelectorAll(".graph-section");

  if (!graphSections.length) {
    return;
  }

  const revealGraphSection = (section) => {
    section.classList.add("is-visible");
  };

  const checkGraphSections = () => {
    graphSections.forEach((section) => {
      if (section.classList.contains("is-visible")) {
        return;
      }

      const graph = section.querySelector(".voice-graph");
      const target = graph || section;
      const rect = target.getBoundingClientRect();

      if (rect.top <= window.innerHeight * .78) {
        revealGraphSection(section);
      }
    });
  };

  if (!("IntersectionObserver" in window)) {
    checkGraphSections();
    window.addEventListener("scroll", checkGraphSections, { passive: true });
    window.addEventListener("resize", checkGraphSections);
    return;
  }

  const graphObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      revealGraphSection(entry.target.closest(".graph-section") || entry.target);
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: "0px 0px -18%",
    threshold: .1,
  });

  graphSections.forEach((section) => {
    graphObserver.observe(section.querySelector(".voice-graph") || section);
  });

  checkGraphSections();
  window.addEventListener("scroll", checkGraphSections, { passive: true });
  window.addEventListener("resize", checkGraphSections);

  // SP時のグラフ横スクロールドット
  document.querySelectorAll(".voice-graph__slider").forEach((slider) => {
    const dots = slider.parentElement.querySelector(".voice-graph__dots");
    const slides = Array.from(slider.querySelectorAll(".survey-score"));

    if (!dots || slides.length <= 1) {
      return;
    }

    const dotButtons = slides.map((slide, index) => {
      const dot = document.createElement("button");
      dot.className = "voice-graph__dot";
      dot.type = "button";
      dot.setAttribute("aria-label", `${index + 1}番目のグラフを表示`);
      dot.addEventListener("click", () => {
        slider.scrollTo({
          left: slide.offsetLeft - slider.offsetLeft - 34,
          behavior: "smooth",
        });
      });
      dots.appendChild(dot);
      return dot;
    });

    const updateDots = () => {
      const sliderCenter = slider.scrollLeft + slider.clientWidth / 2;
      let activeIndex = 0;
      let activeDistance = Infinity;

      slides.forEach((slide, index) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        const distance = Math.abs(sliderCenter - slideCenter);

        if (distance < activeDistance) {
          activeDistance = distance;
          activeIndex = index;
        }
      });

      dotButtons.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === activeIndex);
      });
    };

    slider.addEventListener("scroll", updateDots, { passive: true });
    window.addEventListener("resize", updateDots);
    updateDots();
  });
})();
